<template>
    <a class="item_link">
        <span>
            <b-dropdown v-cloak size="md" right toggle-class="item_link_style" menu-class="menu_link_style" no-caret>
                <template v-slot:button-content>
                    <img src="/img/iconos/campana.svg" alt="Notificaciones">
                    <div class="count-circle-main" v-if="notificacionesCount">{{ notificacionesCount }}</div>
                </template>
                <b-dropdown-text class="campana-title-dropdown-text">
                  <div class="campana-title">Notificaciones</div>
                </b-dropdown-text>
                <template v-if="notificacionesCount">
                    <b-dropdown-item v-if="pedidosSinPagarCount" :href="route('account.pedidos')">
                        Pedidos sin pagar
                        <div class="count-circle">{{ pedidosSinPagarCount }}</div>
                    </b-dropdown-item>
                    <b-dropdown-item v-if="valoracionesCount" :href="route('account.valoraciones')">
                        Valoraciones nuevas
                        <div class="count-circle">{{ valoracionesCount }}</div>
                    </b-dropdown-item>
                </template>
                <b-dropdown-text v-else class="campana-title-dropdown-text">
                  <div class="campana-no-notificaciones">No tienes notificaciones</div>
                </b-dropdown-text>
            </b-dropdown>
        </span>
    </a>
</template>

<script>
export default {
    name: "CampanaNotificaciones",
    props: {
        valoracionesCount: {
            type: Number,
            default: 0
        },
        pedidosSinPagarCount: {
            type: Number,
            default: 0
        }
    },
    computed: {
        notificacionesCount() {
            return this.valoracionesCount + this.pedidosSinPagarCount;
        }
    }
}
</script>

<style scoped>
.campana-title {
    padding: 0.25rem 1.5rem;
    font-size: 1.2em;
    font-weight: bold;
}

.campana-no-notificaciones {
    padding: 0.25rem 0.5rem;
    font-size: 0.9em;
    text-align: center;
}

.count-circle {
    display: inline-block;
    background-color: red;
    line-height: 1;
    padding: 4px 6px;
    border-radius: 9px;
    color: #ffffff;
    font-size: 11px;
}

.count-circle-main {
    display: inline-block;
    background-color: red;
    line-height: 1;
    padding: 3px 4px;
    border-radius: 7px;
    color: #ffffff;
    font-size: 10px;
    position: absolute;
    top: -5px;
    right: -15px;
    min-width: 15px;
}

</style>

<style>
.campana-title-dropdown-text .b-dropdown-text {
    margin-bottom: 0;
}
</style>
